import React, { useRef } from 'react';

export interface HiddenFileInputModel {
  uploadRef: React.RefObject<HTMLInputElement>;
  showUploadDialog: (e: MouseEvent) => void;
}

const useFileUploadRef = (): HiddenFileInputModel => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const showUploadDialog = (e: MouseEvent) => {
    e.preventDefault();
    fileInputRef.current?.click();
  };

  return {
    showUploadDialog,
    uploadRef: fileInputRef,
  };
};

export default useFileUploadRef;
